<template>
  <label
    class="RadioButton"
    @click="onRadioButtonClick">
    <input
      class="HiddenInput"
      type="radio"
      :value="value"
      :checked="isSelected"
      :name="groupName"/>
    <span
      :class="{ 'IsActive': isSelected }"
      class="RadioIcon"/>
    <span class="RadioText">{{ text }}</span>
  </label>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    groupName: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    selectedValue: {
      type: String,
      required: true,
    },
  },
  computed: {
    isSelected() {
      return this.selectedValue === this.value
    },
  },
  methods: {
    onRadioButtonClick() {
      this.$emit('radio-button-click', this.value)
    },
  },
}
</script>

<style lang="stylus" scoped>
  .RadioButton
    display flex
    align-items center
    cursor pointer

  .HiddenInput
    display none

  .RadioIcon
    position relative
    circle(30px)
    flex-center-children()
    flex-shrink 0
    background-color #fff
    border 1px solid $color_grey_light
    margin-right 10px
    &.IsActive
      &:after
        content ''
        circle(70%)
        background-color $color_primary

  .RadioText
    font-size 1.125rem
</style>
